<template>
  <div id="chord-data" :style="{width: '100%', height: '100%'}"></div>
</template>

<script>
export default {
  name: "scholarChord",
  props: ["data"],
  data() {
    return {
      chordData: null,
    }
  },
  watch:{
    data:{
      handler(){
        this.getOption()
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.getOption()
    })
  },
  methods: {
    getOption() {
      this.chordData = this.$echarts.init(document.getElementById('chord-data'));
      let option = {
        tooltip: {},
        series: [
          {
            type: 'graph',
            layout: 'circular',
            circular: {rotateLabel: true},
            data: this.data.nodes,
            links: this.data.links,
            categories: this.data.cats,
            roam: true,
            label: {
              normal: {
                position: 'right',
                formatter: '{b}'
              }
            },
            lineStyle: {
              normal: {
                color: 'source',
                curveness: 0.3
              }
            }
          }
        ]
      }
      this.chordData.off("click");
      this.chordData.off("mouseover");
      this.chordData.on('click', function () {
        // _this.$router.push({path: '/searchTechnology', query: {type: -1, name: p.data.name}})
      });
      this.chordData.setOption(option);
      window.addEventListener('resize', () => {
        this.chordData.resize();
      })
    }

  }
}
</script>

<style scoped>

</style>
